exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-dc190e32]{margin:2px;font-weight:unset}.content-img[data-v-dc190e32]{display:flex;justify-content:center}.content-img>img[data-v-dc190e32]{height:300px}.m-auto[data-v-dc190e32]{margin:auto}.divider[data-v-dc190e32]{margin:auto;text-align:center;height:300px;width:.25rem;background:linear-gradient(180deg,#d27ff9,#a84ff7,#9246df,#9641cc)}#content-cards-professional[data-v-dc190e32]{margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dc190e32","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/components/frp/CardProfessional.vue
// module id = 2082
// module chunks = 2